import axios from 'axios';
import { setSession } from './appUtils';

export const login = (data, navigate, onError, setLoading) => {
  axios
    .post(`auth/userLogin`, data)
    .then((res) => {
      setSession(res.data.data.expiresAt);
      setLoading(false);
      navigate('/subscription');
    })
    .catch((err) => {
      setLoading(false);
      onError(err.response);
    });
};

export const getSubscriptionDetail = (
  onResponse,
  onError,
  setSubscriptionLoading
) => {
  axios
    .get(`/subscription/getSubscriptionDetail`)
    .then((res) => {
      onResponse(res);
      setSubscriptionLoading(false);
    })
    .catch((err) => {
      setSubscriptionLoading(false);
      onError(err.response);
    });
};

export const planDetails = (onResponse, onError, setPlanLoading) => {
  axios
    .get(`subscription/planDetails`)
    .then((res) => {
      onResponse(res);
      setPlanLoading(false);
    })
    .catch((err) => {
      onError(err.response);
      setPlanLoading(false);
    });
};

export const createSession = (data, onSuccessCreateSession, onError) => {
  axios
    .post(`subscription/createSession`, data)
    .then((res) => {
      onSuccessCreateSession(res);
    })
    .catch((err) => {
      onError(err.response);
    });
};

export const subscriptionCancel = (
  sID,
  onSuccessCancelSubscription,
  onError,
  setCancelSubscriptionLoading
) => {
  axios
    .post(`subscription/cancel?id=${sID}`, {})
    .then((res) => {
      setCancelSubscriptionLoading(false);
      onSuccessCancelSubscription(res);
    })
    .catch((err) => {
      setCancelSubscriptionLoading(false);
      onError(err.response);
    });
};

export const forgotPassword = (
  data,
  onSuccess,
  onError,
  setLoading
) => {
  axios
    .post(`auth/forgotPassword`, data)
    .then((res) => {
      setLoading(false);
      onSuccess(res.data);
    })
    .catch((err) => {
      setLoading(false);
      onError(err.response);
    });
};

export const updatePaymentInfo = (onSuccess, onError) => {
  axios
    .post(`subscription/updatePaymentInfo`, {})
    .then((res) => {
      onSuccess(res.data);
    })
    .catch((err) => {
      onError(err.response);
    });
};